interface NavItemProps {
  icon: string;
  label: string;
  onClick?: () => void;
  href?: string;
  className?: string;
}

export function NavItem({ icon, label, onClick, href, className = "" }: NavItemProps) {
  const inner = (
    <>
      <img className="header-icon" src={icon} alt={label} />
      <div className="icon-label">{label}</div>
    </>
  );

  if (href) {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className={`icon-container ${className}`}
      >
        {inner}
      </a>
    );
  }

  return (
    <div className={`icon-container ${className}`} onClick={onClick} role="button" tabIndex={0}>
      {inner}
    </div>
  );
}
